// Backend languageId eşlemesi (docs/LMS-Lookup-Translation-API.md §1) — diğer ekranlardaki
// (ör. AnnouncementTypeForm) sırayla KARIŞTIRMAYIN, LMS ucu bu id'leri bekliyor:
// 1=EN, 2=TR, 3=DE, 4=FR, 5=IT, 6=RO.
// Form ve Table bileşenleri aynı listeyi paylaşır ki iki yerde farklı id sırası riski olmasın.
export const LMS_SUPPORTED_LANGUAGES = [
    { id: 1, code: 'en', name: 'English' },
    { id: 2, code: 'tr', name: 'Türkçe' },
    { id: 3, code: 'de', name: 'Deutsch' },
    { id: 4, code: 'fr', name: 'Français' },
    { id: 5, code: 'it', name: 'Italiano' },
    { id: 6, code: 'ro', name: 'Română' }
];

/**
 * `translations` dizisinden belirli bir `languageId`'ye ait metni döner.
 * @param {Array<{languageId: number, text: string}>} translations
 * @param {number} languageId
 * @returns {string}
 */
export const getLmsTranslationText = (translations, languageId) => {
    if (!Array.isArray(translations)) return '';
    const match = translations.find((t) => t.languageId === languageId);
    return match?.text || '';
};

/**
 * `getLmsTranslationText`in genel hali — `text` dışında alan adı taşıyan diziler için
 * (ör. ön koşul tanımlarındaki `precondition`/`description`).
 * @param {Array<Record<string, any>>} translations
 * @param {number} languageId
 * @param {string} field
 * @returns {string}
 */
export const getLmsTranslationField = (translations, languageId, field) => {
    if (!Array.isArray(translations)) return '';
    const match = translations.find((t) => t.languageId === languageId);
    return match?.[field] || '';
};
